export const requestAmendmentThead: string[] = [
    'STATUS',
    'NOTES',
    'PROPOSAL AS',
    'GROUP NAME',
    'PRODUCT',
    'PREPARED BY',
];
